<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      {{ heroTitle }}
      <router-link slot="right" :to="heroRouterLinkBack" class="button mr-3 is-secondary">
        {{ heroRouterLinkBackLabel }}
      </router-link>
      <router-link slot="right" :to="heroRouterLinkTo" class="button">
        {{ heroRouterLinkLabel }}
      </router-link>
    </hero-bar>
    <b-loading v-model="isLoading"></b-loading>
    <section class="section is-main-section client-detail-page">
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <div class="tile is-child">
            <card-component
              v-if="isProfileExists"
              title="Kunde Detailansicht"
              icon="account"
            >
              <b-notification
                v-if="!data.active"
                has-icon
                type="is-danger"
                role="alert"
                :closable="false"
              >
                <b>Dieser Kunde ist inaktiv.</b><br />Es können keine Aktionen
                ausgeführt werden.
              </b-notification>
              <b-notification
                v-else-if="data.block"
                has-icon
                type="is-danger"
                role="alert"
                :closable="false"
              >
                <b>Dieser Kunde ist gesperrt.</b><br />Es können keine Aktionen
                ausgeführt werden.
                <b-button
                  v-if="hasPermission('customer.block')"
                  class="is-success reblock-button"
                  @click.prevent="blockCustomer"
                  >Kunde freigeben
                </b-button>
              </b-notification>
              <div class="buttons" v-else>
                <router-link
                  v-if="hasPermission('order.create')"
                  :to="'/order/create/' + data.id"
                  class="button"
                  >Einmalkauf tätigen
                </router-link>
                <router-link
                  v-if="hasPermission('saving-plan.create')"
                  :to="'/saving-plan/create/' + data.id"
                  class="button"
                  >Sparplan anlegen
                </router-link>
                <b-button
                  v-if="hasPermission('customer.pdf')"
                  @click.prevent="showPdf"
                  >PDF anzeigen
                </b-button>
                <b-button
                  v-if="hasPermission('customer.pdf')"
                  @click.prevent="printPdf"
                  >PDF drucken
                </b-button>
                <b-button
                  v-if="hasPermission('customer.block')"
                  class="is-danger"
                  @click.prevent="blockCustomer"
                  >Kunde sperren
                </b-button>
              </div>
              <b-field label="Steuer Id">
                {{ data.tax_id }}
              </b-field>
              <b-field label="Personennummer (agree21)">
                {{ data.personnumber }}
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field label="Name">
                    {{ data.salutation_translated }} {{ data.title }}
                    {{ data.first_name }} {{ data.last_name }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Adresse">
                    {{ data.street }} {{ data.house_number }}<br />
                    {{ data.zip }} {{ data.city }}<br />
                    {{ data.additional_address }}<br />
                    {{ data.country_translated }}
                  </b-field>
                </div>
              </div>
              <b-field label="Kontakt">
                <b-button
                  type="is-text"
                  icon-left="email"
                  expanded
                  tag="a"
                  :href="'mailto:' + data.email"
                  >{{ data.email }}
                </b-button>
                <br />
                <b-button
                  type="is-text"
                  icon-left="phone"
                  expanded
                  tag="a"
                  :href="'tel:' + data.tel"
                  >{{ data.tel }}
                </b-button>
              </b-field>

              <template v-if="hasMultipleBanks === true">
                <b-field label="Bank">
                  {{ banks[form.bank] }}
                </b-field>
              </template>
              <template v-else>
                <b-field label="Bank">
                  {{ form.bank_name }}
                </b-field>
              </template>
              <b-field label="Provision">
                {{
                  form.commission_value === 0
                    ? data.partner_bank_commission - 2
                    : form.commission_value - 2
                }}
                %
              </b-field>
              <b-field label="Berater (Beraternummer)">
                {{ data.partner_employee.first_name }}
                {{ data.partner_employee.last_name }}
                ({{ data.partner_employee.employee_number }})
              </b-field>
              <b-button
                v-if="hasPermission('customer.reassignemployee')"
                @click.prevent="reassignEmployee"
                >Berater neu zuweisen
              </b-button>
            </card-component>
          </div>
        </div>
        <div class="tile is-parent">
          <div class="tile is-child">
            <card-component
              v-if="isProfileExists"
              title="Kunde Ausweisdaten"
              icon="account"
            >
              <b-field label="Ausweisnummer">
                {{ data_identity.id_number }}
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field label="Titel">
                    {{ data_identity.title }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Vorname">
                    {{ data_identity.first_name }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Nachname">
                    {{ data_identity.last_name }}
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Geburtsort">
                    {{ data_identity.birth_place }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Geburtsdatum">
                    {{ data_identity.birth_date }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Geburtsland">
                    {{ data_identity.birth_country_translated }}
                  </b-field>
                </div>
              </div>
              <hr />
              <b-field label="Straße">
                {{ data_identity.street }}
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field label="Postleitzahl">
                    {{ data_identity.zip }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Stadt">
                    {{ data_identity.city }}
                  </b-field>
                </div>
              </div>
              <b-field label="Land">
                {{ data_identity.country_translated }}
              </b-field>
              <hr />
              <div class="columns">
                <div class="column">
                  <b-field label="Ausstelldatum">
                    {{ data_identity.issue }}
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Ablaufdatum">
                    {{ data_identity.expire }}
                  </b-field>
                </div>
              </div>
              <b-field label="Ausstellende Behörde">
                {{ data_identity.authority }}
              </b-field>
              <b-field label="Art des Ausweises">
                {{ data_identity.doctype_translated }}
              </b-field>
              <template v-if="customer_extra_fields.length > 0">
                <hr />
                <h5 class="is-size-5">Zusätzliche Daten</h5>
                <extra-field-print
                  v-for="field in customer_extra_fields"
                  :key="field.id"
                  :field="field"
                  :value="data_extra_fields[field.name]"
                />
              </template>
            </card-component>
          </div>
        </div>
      </div>
      <template v-if="data.active && !data.block">
        <div v-if="isProfileExists">
          <vault-list
            v-if="hasPermission('vault.list')"
            :customerId="data.id"
          />
          <tiles v-if="hasPermission('saving-plan.list')">
            <card-component
              title="Sparpläne"
              icon="piggy-bank"
              class="tile is-child"
            >
              <saving-plan-list :customerId="data.id" />
              <template v-if="hasPermission('saving-plan.export')">
                <div class="button" v-on:click="viewExport">
                  {{ exportLinkLabel }}
                </div>
              </template>
            </card-component>
          </tiles>
          <tiles v-if="hasPermission('order.list')">
            <card-component
              title="Abrechnungen"
              icon="format-list-bulleted"
              class="tile is-child"
            >
              <order-list :customerId="data.id" />
            </card-component>
          </tiles>
        </div>
      </template>
      <div to="popup" class="fixBox">
        <alert
          v-if="showExport"
          title="Download Transaktionsdaten"
          @close="closePopup"
        >
          <div id="progressWindow" class="selectform">
            <template v-if="startExport === true">
              <div class="content has-text-grey has-text-centered">
                <p>Daten werden exportiert:</p>
              </div>
              <template v-if="loadingExport === true">
                <div class="content has-text-grey has-text-centered">
                  <b-icon icon="dots-horizontal" size="is-large" />
                </div>
              </template>
            </template>
            <template v-if="exportDone === true">
              <h3 class="is-success-passive">Abgeschlossen</h3>
            </template>
          </div>
          <downloadCsv
            class="
              button
              mr-0
              mb-0
              is-size-6-touch is-size-5-desktop is-primary
            "
            :data="json_data"
            name="savingplans.csv"
            :disabled="disableDownloadBtn"
            delimiter=";"
          >
            Download CSV
          </downloadCsv>
        </alert>
        <alert
          v-if="showAssignEmployee"
          title="Berater neu zuweisen"
          @close="closePopup"
        >
          <b-field label="Berater*">
            <b-select v-model="employee" placeholder="Berater" expanded>
              <option
                v-for="option in employees"
                :value="option.id"
                :key="option.id"
              >
                {{ option.first_name }} {{ option.last_name }}
              </option>
            </b-select>
          </b-field>
          <b-button @click="setEmployee"> Berater zuweisen </b-button>
        </alert>
      </div>
    </section>
  </div>
</template>

<script>
// import store from '@/store'
import TitleBar from '@/components/TitleBar'
import HeroBar from '@/components/HeroBar'
import Tiles from '@/components/Tiles'
import CardComponent from '@/components/CardComponent'
import { oaxios } from '@/_helpers'
import { mapGetters, mapState } from 'vuex'
import VaultList from '@/components/CustomerVaultList'
import SavingPlanList from '@/components/SavingPlanList'
import OrderList from '@/components/OrderList'
import router from '@/router'
import ExtraField from '@/components/ExtraFields/ExtraField'
import ExtraFieldPrint from '@/components/ExtraFields/Print/ExtraFieldPrint'
import printJS from 'print-js'
import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
import Alert from '@/components/Alert'

Vue.component('downloadCsv', JsonCSV)

export default {
  name: 'ClientForm',
  components: {
    ExtraFieldPrint,
    ExtraField,
    VaultList,
    SavingPlanList,
    OrderList,
    CardComponent,
    Tiles,
    HeroBar,
    TitleBar,
    Alert,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isLoadingClient: false,
      isLoadingIdentity: false,
      isSaving: false,
      banks: null,
      form: this.getClearFormObject(),
      data: this.getClearFormObject(),
      form_identity: this.getClearFormIdentityObject(),
      data_identity: this.getClearFormIdentityObject(),
      form_extra_fields: {},
      data_extra_fields: {},
      createdReadable: null,
      isProfileExists: false,
      required: {
        tax_id: true,
        identity: true,
      },
      exportLinkLabel: 'Export',
      showExport: false,
      json_data: [{}],
      disableDownloadBtn: true,
      startExport: false,
      loadingExport: false,
      exportDone: false,
      heroRouterLinkBack: '/client',
      heroRouterLinkBackLabel: 'Zurück',
      hasMultipleBanks: false,
      activeSubTab: 1,
      button_toggle_text: 'Weiter',
      customer_declaration_class: '',
      customer_tac_class: '',
      showAssignEmployee: false,
      employee: '',
      employees: [],
      userBank: null,
      agbPath: '/' + process.env.VUE_APP_FILE_PATH_AGB,
      commissionByEmployee: false,
    }
  },
  computed: {
    ...mapState('helper', [
      'salutations',
      'titles',
      'countries',
      'commissions',
      'all_countries',
      'doctype',
      'assets_origins',
      'usage_backgrounds',
      'required_fields',
      'customer_extra_fields',
      'employerbank',
    ]),
    ...mapState('account', ['user']),
    ...mapGetters('permission', ['hasPermission']),
    checkPermission: function () {
      return {
        tile:
          this.hasPermission('customer.put') &&
          this.hasPermission('customer.create'),
        'is-child':
          this.hasPermission('customer.put') &&
          this.hasPermission('customer.create'),
      }
    },
    checkPermissionParent: function () {
      return {
        tile:
          this.hasPermission('customer.put') &&
          this.hasPermission('customer.create'),
        'is-parent':
          this.hasPermission('customer.put') &&
          this.hasPermission('customer.create'),
      }
    },
    ifForm() {
      return (
        (this.hasPermission('customer.put') && this.isProfileExists) ||
        (this.hasPermission('customer.create') && !this.isProfileExists)
      )
    },
    ifFormIdentity() {
      return this.hasPermission('customer.identity.put')
    },
    isLoading() {
      return this.isLoadingClient || this.isLoadingIdentity
    },
    fullName() {
      return (
        this.data.salutation_translated +
        ' ' +
        (this.data.title ? this.data.title + ' ' : '') +
        this.data.first_name +
        ' ' +
        this.data.last_name
      )
    },
    titleStack() {
      let lastCrumb

      if (this.isProfileExists) {
        lastCrumb = this.fullName
      } else {
        lastCrumb = 'Neuer Kunde'
      }

      return ['Kunden', lastCrumb]
    },
    heroTitle() {
      if (this.isProfileExists) {
        return this.fullName
      } else {
        return 'Kunde Detailansicht'
      }
    },
    heroRouterLinkTo() {
      if (this.isProfileExists && this.hasPermission('customer.create')) {
        return { name: 'client.new' }
      } else {
        return { name: 'client.list' }
      }
    },
    heroRouterLinkLabel() {
      if (this.isProfileExists && this.hasPermission('customer.create')) {
        return 'Neuer Kunde'
      } else {
        return 'Kundenübersicht'
      }
    },
    formCardTitle() {
      if (this.isProfileExists) {
        return 'Kundendaten bearbeiten'
      } else {
        return 'Neuer Kunde'
      }
    },
  },
  watch: {
    required_fields: {
      deep: true,
      handler(newValue) {
        this.required.tax_id = newValue.tax_id === 1
        this.required.identity = newValue.identity === 1
      },
    },
    id(newValue) {
      this.isProfileExists = false

      if (!newValue) {
        this.reset()
        this.form = this.getClearFormObject()
        this.data = this.getClearFormObject()
        this.form_identity = this.getClearFormIdentityObject()
        this.data_identity = this.getClearFormIdentityObject()
      } else {
        this.getData()
      }
    },
    activeSubTab() {
      if (this.activeSubTab === 1) {
        this.button_toggle_text = 'Zurück'
      } else {
        this.button_toggle_text = 'Weiter'
      }
    },
    'form_identity.first_name'(newValue) {
      this.form.first_name = newValue;
    },
    'form_identity.last_name'(newValue) {
      this.form.last_name = newValue;
    },
    'form_identity.street'(newValue) {
      this.form.street = newValue;
    },
    'form_identity.house_number'(newValue) {
      this.form.house_number = newValue;
    },
    'form_identity.zip'(newValue) {
      this.form.zip = newValue;
    },
    'form_identity.city'(newValue) {
      this.form.city = newValue;
    },
    'form_identity.country'(newValue) {
      this.form.country = newValue;
    },
  },
  created() {
    this.required.tax_id = this.required_fields.tax_id === 1
    this.required.identity = this.required_fields.identity === 1
    this.getBanks()
    this.getData()
  },
  methods: {
    goToFormIdentity() {
      if (this.activeSubTab === 0) {
        this.activeSubTab = 1
        this.button_toggle_text = 'Zurück'
      } else {
        this.activeSubTab = 0
        this.button_toggle_text = 'Weiter'
      }
    },
    showPdf() {
      if (this.hasPermission('customer.pdf')) {
        this.submitting = true
        const data = {
          customer_id: this.data.id,
        }
        oaxios('customer/pdf', data, 'post', 'blob')
          .then((r) => {
            const reader = new FileReader()
            reader.readAsDataURL(r.data)
            reader.onloadend = () => {
              const base64data = reader.result
              const w = window.open('about:blank', '_blank')
              w.document.write(
                "<html lang='de'><head><title>Vertrag</title></head><body style='margin: 0; overflow: hidden'><iframe style='width: 100%; height: 100%' src='" +
                  base64data +
                  "'></iframe></body></html>",
              )
            }
          })
          .catch(() => {})
          .finally(() => {
            this.submitting = false
          })
      }
    },
    printPdf() {
      if (this.hasPermission('customer.pdf')) {
        this.submitting = true
        const data = {
          customer_id: this.data.id,
        }
        oaxios('customer/pdf', data, 'post', 'blob')
          .then((r) => {
            const reader = new FileReader()
            reader.readAsDataURL(r.data)
            reader.onloadend = () => {
              const base64data = reader.result
              printJS({
                printable: base64data.replace(
                  'data:application/pdf;base64,',
                  '',
                ),
                type: 'pdf',
                base64: true,
                showModal: true,
                modalMessage: 'Lade PDF',
              })
            }
          })
          .catch(() => {})
          .finally(() => {
            this.submitting = false
          })
      }
    },
    copyCustomerForm() {
      this.form_identity.title = this.titles[this.form.title]
      this.form_identity.first_name = this.form.first_name
      this.form_identity.last_name = this.form.last_name

      if (this.form.street && this.form.house_number)
        this.form_identity.street =
          this.form.street + ' ' + this.form.house_number
      else if (this.form.street) this.form_identity.street = this.form.street
      else if (this.form.house_number)
        this.form_identity.street = this.form.house_number
      else this.form_identity.street = ''

      this.form_identity.zip = this.form.zip
      this.form_identity.city = this.form.city
      this.form_identity.country = this.form.country
    },
    getClearFormObject() {
      return {
        id: null,
        personnumber: '0000',
        email: null,
        customer_number: null,
        salutation: null,
        salutation_translated: null,
        title: null,
        first_name: null,
        last_name: null,
        company: null,
        street: null,
        house_number: null,
        additional_address: null,
        zip: null,
        city: null,
        country: null,
        country_translated: null,
        tel: null,
        active: true,
        bank: null,
        banks: null,
        commission_value: null,
        tax_id: null,
        consent_advice: null,
        consent_advertise: null,
        assets_origin: null,
        usage_background: null,
        customer_declaration: null,
        customer_tac: null,
        partner_employee: {
          role_id: 0,
        },
      }
    },
    getClearFormIdentityObject() {
      return {
        id_number: null,
        title: null,
        first_name: null,
        last_name: null,
        birth_place: null,
        birth_date: null,
        birth_country: null,
        nationality: null,
        street: null,
        house_number: null,
        zip: null,
        city: null,
        country: null,
        issue: null,
        expire: null,
        authority: null,
        doctype: null,
      }
    },
    getData() {
      if (this.$route.params.id) {
        this.isLoadingClient = true
        this.isLoadingIdentity = true
        const data = {
          customer_id: this.$route.params.id,
        }

        if (this.hasPermission('customer.get')) {
          oaxios('/customer', data)
            .then((r) => {
              const item = r.data.data
              if (item) {
                item.extra_fields = JSON.parse(item.extra_fields)
                this.data = { ...item }
                this.form = { ...item }
                this.bank = item.bank

                this.data_extra_fields = { ...item.extra_fields }
                this.form_extra_fields = { ...item.extra_fields }

                this.isProfileExists = true

              } else {
                this.$router.push({ name: 'client.new' })
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoadingClient = false
            })
        } else this.isLoadingClient = false

        if (this.hasPermission('customer.identity.get')) {
          oaxios('/customer-identity', data)
            .then((r) => {
              const item = r.data.data
              if (item) {

                this.data_identity = { ...item }
                this.form_identity = { ...item }
              } else {
                this.$router.push({ name: 'client.new' })
              }
            })
            .catch(() => {})
            .finally(() => {
              this.isLoadingIdentity = false
            })
        } else this.isLoadingIdentity = false
      }
      if (this.hasPermission('bank.list')) {
        this.getBanks()
      } else {
        if (this.employerbank) {
          sessionStorage.setItem('userBank', JSON.stringify(this.employerbank))
        }
        this.userBank = JSON.parse(sessionStorage.getItem('userBank'))
      }
    },
    getBanks() {
      if (this.hasPermission('bank.list')) {
        this.hasMultipleBanks = true
        const data = { pagination: false }
        oaxios('/bank/list', data)
          .then((r) => {
            const res = r.data.data
            const banks = []
            res.forEach(function (bank) {
              banks.push([bank.id, bank.name])
            })
            this.banks = Object.fromEntries(banks)
          })
          .catch(() => {})
      }
    },
    checkCommissionByEmployee() {
      const bankId = Object.keys(
        JSON.parse(sessionStorage.getItem('userBank')),
      )[0]
      oaxios('/bank/commission-by-employee', { id: bankId })
        .then((r) => {
          if (r.data.is_commission_by_employee_available === 1) {
            this.commissionByEmployee = true
          } else {
            this.commissionByEmployee = false
          }
        })
        .catch(() => {})
    },
    submit() {
      if (this.ifForm) {
        this.isSaving = true

        const data = {
          customer_id: this.form.id,
          personnumber: this.form.personnumber,
          email: this.form.email,
          customer_number: this.form.customer_number,
          salutation: this.form.salutation,
          title: this.form.title,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          company: null,
          street: this.form.street,
          house_number: this.form.house_number,
          additional_address: this.form.additional_address,
          zip: this.form.zip,
          city: this.form.city,
          country: this.form.country,
          tel: this.form.tel,
          active: this.form.active,
          tax_id: this.form.tax_id,
          bank: this.form.bank,
          commission_value: this.form.commission_value,
          extra_field_values: this.form_extra_fields,
          consent_advertise: this.form.consent_advertise,
          consent_advice: this.form.consent_advice,
          assets_origin: this.form.assets_origin,
          usage_background: this.form.usage_background,
          customer_declaration: this.form.customer_declaration,
          customer_tac: this.form.customer_tac,
        }

        oaxios('/customer/put', data)
          .then((r) => {
            this.data = { ...this.form }
            this.data_extra_fields = { ...this.form_extra_fields }
            if (this.ifFormIdentity) {
              const data = {
                customer_id: r.data.customer_id,
                id_number: this.form_identity.id_number,
                title: this.form_identity.title,
                first_name: this.form_identity.first_name,
                last_name: this.form_identity.last_name,
                birth_place: this.form_identity.birth_place,
                birth_date: this.form_identity.birth_date,
                birth_country: this.form_identity.birth_country,
                nationality: this.form_identity.nationality,
                street: this.form_identity.street+' '+this.form_identity.house_number,
                zip: this.form_identity.zip,
                city: this.form_identity.city,
                country: this.form_identity.country,
                issue: this.form_identity.issue,
                expire: this.form_identity.expire,
                authority: this.form_identity.authority,
                doctype: this.form_identity.doctype,
                profil_exists: this.isProfileExists,
              }

              oaxios('/customer-identity/put', data)
                .then((r) => {
                  this.$buefy.toast.open({
                    message: `${r.data.success}`,
                    type: 'is-success',
                    queue: false,
                  })
                  if (!this.isProfileExists) {
                    this.data.id = data.customer_id
                    this.showPdf()
                    router.push('/client/' + data.customer_id)
                  }
                })
                .catch((error) => {
                  this.error = error.response.data.error

                  this.$buefy.toast.open({
                    message: 'Bitte kontrollieren Sie Ihre Eingaben',
                    type: 'is-danger',
                    queue: false,
                  })

                  for (const [key, value] of Object.entries(this.error)) {
                    value[0] = value[0].replace('birth date', 'Geburtsdatum')
                    value[0] = value[0].replace('issue', 'Ausstelldatum')
                    value[0] = value[0].replace('expire', 'Ablaufdatum')
                  }

                  this.$refs.form.setErrors({
                    Geburtsdatum: this.error.birth_date,
                    Ausstelldatum: this.error.issue,
                    Ablaufdatum: this.error.expire,
                  })
                })
                .finally(() => {
                  this.isSaving = false
                })
            } else this.isSaving = false
          })
          .catch((error) => {
            this.error = error.response.data.error

            this.$buefy.toast.open({
              message: 'Bitte kontrollieren Sie Ihre Eingaben',
              type: 'is-danger',
              queue: false,
            })
            if (typeof this.error !== 'undefined') {
              if (typeof this.error.email !== 'undefined') {
                this.$refs.form.setErrors({
                  'E-Mail': this.error.email,
                })
              }
              if (typeof this.error.tax_id !== 'undefined') {
                this.$refs.form.setErrors({
                  'Steuer Id': this.error.tax_id,
                })
              }
            }
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    checkCustomerDeclaration() {
      if (!this.form.customer_declaration) {
        this.customer_declaration_class = 'customer-declaration-denied'
      } else {
        this.customer_declaration_class = ''
      }
    },
    checkCustomerTAC() {
      if (!this.form.customer_tac) {
        this.customer_tac_class = 'customer-declaration-denied'
      } else {
        this.customer_tac_class = ''
      }
    },
    checkForm() {
      this.$refs.form.validate()
      this.checkCustomerDeclaration()
      this.checkCustomerTAC()
      if (this.ifFormIdentity) {
        const data = {
          id_number: this.form_identity.id_number,
          title: this.form_identity.title,
          first_name: this.form_identity.first_name,
          last_name: this.form_identity.last_name,
          birth_place: this.form_identity.birth_place,
          birth_date: this.form_identity.birth_date,
          birth_country: this.form_identity.birth_country,
          nationality: this.form_identity.nationality,
          street: this.form_identity.street+' '+this.form_identity.house_number,
          zip: this.form_identity.zip,
          city: this.form_identity.city,
          country: this.form_identity.country,
          issue: this.form_identity.issue,
          expire: this.form_identity.expire,
          authority: this.form_identity.authority,
          doctype: this.form_identity.doctype,
          profil_exists: this.isProfileExists,
        }

        oaxios('/customer-identity/check', data)
          .then((r) => {
            this.submit()
          })
          .catch((error) => {
            this.error = error.response.data.error

            this.$buefy.toast.open({
              message: 'Bitte kontrollieren Sie Ihre Eingaben',
              type: 'is-danger',
              queue: false,
            })

            for (const [key, value] of Object.entries(this.error)) {
              value[0] = value[0].replace('birth date', 'Geburtsdatum')
              value[0] = value[0].replace('issue', 'Ausstelldatum')
              value[0] = value[0].replace('expire', 'Ablaufdatum')
            }

            this.$refs.form.setErrors({
              Geburtsdatum: this.error.birth_date,
              Ausstelldatum: this.error.issue,
              Ablaufdatum: this.error.expire,
            })
          })
          .finally(() => {})
      }
    },
    checkFormViaCommission() {
      if (this.isProfileExists) {
        this.checkForm()
      }
    },
    reset() {
      requestAnimationFrame(() => {
        this.$refs.form.reset()
      })
    },
    errorObjectToArray(errorObj) {
      const values = []
      for (const key in errorObj) {
        // eslint-disable-next-line no-prototype-builtins
        if (errorObj.hasOwnProperty(key)) {
          const errors = errorObj[key]
          for (const value of errors) {
            values.push(value)
          }
        }
      }
      return values
    },
    viewExport() {
      if (!this.hasPermission('saving-plan.export')) {
        return
      }
      this.showExport = true
      this.exportSavingplans()
    },
    exportSavingplans() {
      if (!this.hasPermission('saving-plan.export')) {
        return
      }
      this.startExport = true
      this.loadingExport = true
      const data = { onlyCustomerData: this.form.id }
      oaxios('/saving-plan/export', data).then((response) => {
        this.json_data = response.data.data
        this.exportDone = true
        this.loadingExport = false
        this.disableDownloadBtn = false
      })
    },
    closePopup() {
      this.showExport = false
      this.json_data = [{}]
      this.disableDownloadBtn = true
      this.startExport = false
      this.loadingExport = false
      this.exportDone = false
      this.showAssignEmployee = false
    },
    checkBirthDate(e) {
      // console.log(e.target)
    },
    blockCustomer() {
      if (!this.hasPermission('customer.block')) {
        return
      }
      const data = { customer_id: this.form.id }
      oaxios('/customer/block', data)
        .then((r) => {
          if (r.data.data === 1) {
            this.data.block = true
          }
          if (r.data.data === 0) {
            this.data.block = false
          }
        })
        .catch((error) => {
          this.error = error.response.data.error

          this.$buefy.toast.open({
            message: 'Kunde konnte nicht gesperrt werden',
            type: 'is-danger',
            queue: false,
          })
        })
    },
    reassignEmployee() {
      if (!this.hasPermission('customer.reassignemployee')) {
        return
      }
      this.showAssignEmployee = true

      const data = {
        bank: this.data.bank,
      }

      oaxios(`employee/list-for-bank`, data).then((r) => {
        this.employees = r.data.employees
        this.employee = this.data.partner_employee.id
      })
    },
    setEmployee() {
      if (!this.hasPermission('customer.reassignemployee')) {
        return
      }
      const data = {
        customer_id: this.data.id,
        employee_id: this.employees[this.employee].id,
      }

      oaxios(`customer/reassign-employee`, data).then((r) => {
        this.data.partner_employee.id = r.data.data.id
        this.data.partner_employee.first_name = r.data.data.first_name
        this.data.partner_employee.last_name = r.data.data.last_name
        this.data.partner_employee.employee_number = r.data.data.employee_number
        this.showAssignEmployee = false
        this.$buefy.toast.open({
          message: `${r.data.success}`,
          type: 'is-success',
          queue: false,
        })
      })
    },
  },
  mounted() {
    this.agbPath = '/' + process.env.VUE_APP_FILE_PATH_AGB
  },
}
</script>
